export default {
    name: process.env.NAME || 'Quote',
    title: process.env.TITLE || 'Quote',
    owner: process.env.OWNER || 'Lusina',
    ownerUrl: process.env.OWNER_URL || 'https://brianlusina.com',
};
